// GENERATED by scripts/prepare_works.py from photos/catalogue.json.
// Do not edit by hand — edit the manifest and re-run `npm run works`.
// Every image here came through the chin-crop step, so no face reaches
// the build unless the manifest deliberately allows one.

export const CATALOGUE = [
  {
    "id": "hoop-autumn-bouquet",
    "title": "Autumn bouquet hoop",
    "category": "embroidery",
    "image": "/works/hoop-autumn-bouquet-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 600,
        "webp": "/works/hoop-autumn-bouquet-480.webp"
      },
      {
        "w": 768,
        "h": 960,
        "webp": "/works/hoop-autumn-bouquet-768.webp"
      },
      {
        "w": 1024,
        "h": 1280,
        "webp": "/works/hoop-autumn-bouquet-1024.webp"
      }
    ],
    "description": "Dried-flower bouquet worked in thread â€” russet leaves, blue and yellow roses, a lavender spike â€” tied with a maroon organza bow.",
    "materials": "Hand embroidery, organza ribbon",
    "tags": [
      "Hoop art",
      "Floral",
      "Bouquet"
    ],
    "featured": true,
    "hasBeforeAfter": false
  },
  {
    "id": "hoop-sabr-roses",
    "title": "Sabr with roses",
    "category": "embroidery",
    "image": "/works/hoop-sabr-roses-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/hoop-sabr-roses-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/hoop-sabr-roses-768.webp"
      },
      {
        "w": 1024,
        "h": 1365,
        "webp": "/works/hoop-sabr-roses-1024.webp"
      }
    ],
    "description": "The word sabr in red thread, wreathed in embroidered roses and leaves, with a yellow satin bow.",
    "materials": "Hand embroidery on cotton",
    "tags": [
      "Hoop art",
      "Calligraphy",
      "Roses"
    ],
    "featured": true,
    "hasBeforeAfter": false
  },
  {
    "id": "hoop-monogram-wreath",
    "title": "Monogram floral wreath",
    "category": "embroidery",
    "image": "/works/hoop-monogram-wreath-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 697,
        "webp": "/works/hoop-monogram-wreath-480.webp"
      },
      {
        "w": 768,
        "h": 1115,
        "webp": "/works/hoop-monogram-wreath-768.webp"
      },
      {
        "w": 1024,
        "h": 1487,
        "webp": "/works/hoop-monogram-wreath-1024.webp"
      }
    ],
    "description": "Two initials joined by a heart inside a wreath of deep-red and cream roses, finished with a red satin bow.",
    "materials": "Hand embroidery, satin bow",
    "tags": [
      "Hoop art",
      "Monogram",
      "Wedding"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "hoop-heart-wreath",
    "title": "Heart wreath for Ummi",
    "category": "embroidery",
    "image": "/works/hoop-heart-wreath-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 600,
        "webp": "/works/hoop-heart-wreath-480.webp"
      },
      {
        "w": 768,
        "h": 960,
        "webp": "/works/hoop-heart-wreath-768.webp"
      },
      {
        "w": 1024,
        "h": 1280,
        "webp": "/works/hoop-heart-wreath-1024.webp"
      }
    ],
    "description": "A heart of pink and burgundy roses around a birthday message, with a pink satin bow at the top of the hoop.",
    "materials": "Hand embroidery, satin bow",
    "tags": [
      "Hoop art",
      "Birthday",
      "Roses"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "hoop-bloom-daisies",
    "title": "Bloom daisies",
    "category": "embroidery",
    "image": "/works/hoop-bloom-daisies-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 600,
        "webp": "/works/hoop-bloom-daisies-480.webp"
      },
      {
        "w": 768,
        "h": 960,
        "webp": "/works/hoop-bloom-daisies-768.webp"
      },
      {
        "w": 1024,
        "h": 1280,
        "webp": "/works/hoop-bloom-daisies-1024.webp"
      }
    ],
    "description": "Five stitched daisies on long stems with the word bloom in flowing thread, tied with a white bow.",
    "materials": "Hand embroidery on cotton",
    "tags": [
      "Hoop art",
      "Daisies",
      "Minimal"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "hoop-gold-ring-wreath",
    "title": "Minimal gold-ring wreath",
    "category": "embroidery",
    "image": "/works/hoop-gold-ring-wreath-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/hoop-gold-ring-wreath-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/hoop-gold-ring-wreath-768.webp"
      },
      {
        "w": 1024,
        "h": 1365,
        "webp": "/works/hoop-gold-ring-wreath-1024.webp"
      }
    ],
    "description": "A thin gold-thread ring with a cluster of peach roses and leaves at its foot. Space left for a name or a date.",
    "materials": "Hand embroidery, gold thread",
    "tags": [
      "Hoop art",
      "Minimal",
      "Personalised"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "hoop-ayat-calligraphy",
    "title": "Ayat calligraphy hoop",
    "category": "embroidery",
    "image": "/works/hoop-ayat-calligraphy-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 600,
        "webp": "/works/hoop-ayat-calligraphy-480.webp"
      },
      {
        "w": 768,
        "h": 960,
        "webp": "/works/hoop-ayat-calligraphy-768.webp"
      },
      {
        "w": 1024,
        "h": 1280,
        "webp": "/works/hoop-ayat-calligraphy-1024.webp"
      }
    ],
    "description": "Arabic calligraphy stitched in black thread with a gold-thread crest, finished with a maroon organza bow.",
    "materials": "Hand embroidery, organza bow",
    "tags": [
      "Hoop art",
      "Calligraphy",
      "Islamic"
    ],
    "featured": true,
    "hasBeforeAfter": false
  },
  {
    "id": "hoop-calligraphy-maroon",
    "title": "Calligraphy with autumn leaves",
    "category": "embroidery",
    "image": "/works/hoop-calligraphy-maroon-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 600,
        "webp": "/works/hoop-calligraphy-maroon-480.webp"
      },
      {
        "w": 768,
        "h": 960,
        "webp": "/works/hoop-calligraphy-maroon-768.webp"
      },
      {
        "w": 1024,
        "h": 1280,
        "webp": "/works/hoop-calligraphy-maroon-1024.webp"
      }
    ],
    "description": "A verse in fine black thread between scrolled gold borders, with small russet leaves at the corners, photographed on maroon satin.",
    "materials": "Hand embroidery, beadwork",
    "tags": [
      "Hoop art",
      "Calligraphy",
      "Gold"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "hoop-inshallah",
    "title": "Inshallah calligraphy",
    "category": "embroidery",
    "image": "/works/hoop-inshallah-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 600,
        "webp": "/works/hoop-inshallah-480.webp"
      },
      {
        "w": 768,
        "h": 960,
        "webp": "/works/hoop-inshallah-768.webp"
      },
      {
        "w": 1024,
        "h": 1280,
        "webp": "/works/hoop-inshallah-1024.webp"
      }
    ],
    "description": "Arabic calligraphy in black thread with a small red heart, on a plain hoop with a yellow satin bow.",
    "materials": "Hand embroidery on cotton",
    "tags": [
      "Hoop art",
      "Calligraphy"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "hoop-anniversary-portrait",
    "title": "Anniversary portrait hoop",
    "category": "embroidery",
    "image": "/works/hoop-anniversary-portrait-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 480,
        "webp": "/works/hoop-anniversary-portrait-480.webp"
      },
      {
        "w": 768,
        "h": 768,
        "webp": "/works/hoop-anniversary-portrait-768.webp"
      },
      {
        "w": 1024,
        "h": 1024,
        "webp": "/works/hoop-anniversary-portrait-1024.webp"
      }
    ],
    "description": "A painted portrait of a couple inside a heart of embroidered red roses, edged with pearls, for a wedding anniversary.",
    "materials": "Painted and embroidered, pearl edge",
    "tags": [
      "Hoop art",
      "Portrait",
      "Anniversary",
      "Personalised"
    ],
    "featured": true,
    "hasBeforeAfter": false
  },
  {
    "id": "art-moonrise-grey",
    "title": "Moonrise over pines, grey",
    "category": "painting",
    "image": "/works/art-moonrise-grey-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 480,
        "webp": "/works/art-moonrise-grey-480.webp"
      },
      {
        "w": 768,
        "h": 768,
        "webp": "/works/art-moonrise-grey-768.webp"
      },
      {
        "w": 1024,
        "h": 1024,
        "webp": "/works/art-moonrise-grey-1024.webp"
      }
    ],
    "description": "A full moon over a black pine line, painted on fabric and mounted in a hoop with a white bow.",
    "materials": "Acrylic on fabric, hoop-mounted",
    "tags": [
      "Painted hoop",
      "Moon",
      "Landscape"
    ],
    "featured": true,
    "hasBeforeAfter": false
  },
  {
    "id": "art-moon-hoops-pair",
    "title": "Moon hoops, a pair",
    "category": "painting",
    "image": "/works/art-moon-hoops-pair-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 480,
        "webp": "/works/art-moon-hoops-pair-480.webp"
      },
      {
        "w": 768,
        "h": 768,
        "webp": "/works/art-moon-hoops-pair-768.webp"
      },
      {
        "w": 1024,
        "h": 1024,
        "webp": "/works/art-moon-hoops-pair-1024.webp"
      }
    ],
    "description": "The grey and the blue moonrise hoops together â€” the same pine line, two skies.",
    "materials": "Acrylic on fabric, hoop-mounted",
    "tags": [
      "Painted hoop",
      "Moon",
      "Pair"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "art-moonrise-blue",
    "title": "Moonrise, blue",
    "category": "painting",
    "image": "/works/art-moonrise-blue-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 480,
        "webp": "/works/art-moonrise-blue-480.webp"
      },
      {
        "w": 768,
        "h": 768,
        "webp": "/works/art-moonrise-blue-768.webp"
      },
      {
        "w": 1024,
        "h": 1024,
        "webp": "/works/art-moonrise-blue-1024.webp"
      }
    ],
    "description": "A hazy moon in a deep-blue sky over black pines, painted on fabric in a hoop.",
    "materials": "Acrylic on fabric, hoop-mounted",
    "tags": [
      "Painted hoop",
      "Moon",
      "Night"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "art-pine-watercolour",
    "title": "Pine forest watercolour",
    "category": "painting",
    "image": "/works/art-pine-watercolour-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 600,
        "webp": "/works/art-pine-watercolour-480.webp"
      },
      {
        "w": 768,
        "h": 960,
        "webp": "/works/art-pine-watercolour-768.webp"
      },
      {
        "w": 1024,
        "h": 1280,
        "webp": "/works/art-pine-watercolour-1024.webp"
      }
    ],
    "description": "Teal pines against a washed sky with two birds, painted loosely on fabric and mounted in a hoop.",
    "materials": "Watercolour on fabric, hoop-mounted",
    "tags": [
      "Painted hoop",
      "Forest",
      "Watercolour"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "art-gold-calligraphy-black",
    "title": "Gold calligraphy on black",
    "category": "painting",
    "image": "/works/art-gold-calligraphy-black-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/art-gold-calligraphy-black-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/art-gold-calligraphy-black-768.webp"
      },
      {
        "w": 1024,
        "h": 1365,
        "webp": "/works/art-gold-calligraphy-black-1024.webp"
      }
    ],
    "description": "Arabic calligraphy in gold on a black canvas, inside a dotted border.",
    "materials": "Gold on black canvas",
    "tags": [
      "Canvas",
      "Calligraphy",
      "Gold"
    ],
    "featured": true,
    "hasBeforeAfter": false
  },
  {
    "id": "art-rainbow-road",
    "title": "Rainbow road hoop",
    "category": "painting",
    "image": "/works/art-rainbow-road-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/art-rainbow-road-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/art-rainbow-road-768.webp"
      },
      {
        "w": 1024,
        "h": 1365,
        "webp": "/works/art-rainbow-road-1024.webp"
      }
    ],
    "description": "A road running into a rainbow-lit sky, painted on fabric and shown on a small wooden easel.",
    "materials": "Acrylic on fabric, hoop-mounted",
    "tags": [
      "Painted hoop",
      "Landscape"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "art-shukr-tawakkul-sabr",
    "title": "Shukr, Tawakkul, Sabr â€” framed set",
    "category": "painting",
    "image": "/works/art-shukr-tawakkul-sabr-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/art-shukr-tawakkul-sabr-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/art-shukr-tawakkul-sabr-768.webp"
      }
    ],
    "description": "Three words in black calligraphy over soft green watercolour washes, each in a slim white frame.",
    "materials": "Watercolour and ink, framed",
    "tags": [
      "Framed",
      "Calligraphy",
      "Set of three"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "art-bouquet-pink-oval",
    "title": "Bouquet in a rose-pink oval",
    "category": "painting",
    "image": "/works/art-bouquet-pink-oval-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 600,
        "webp": "/works/art-bouquet-pink-oval-480.webp"
      },
      {
        "w": 768,
        "h": 960,
        "webp": "/works/art-bouquet-pink-oval-768.webp"
      },
      {
        "w": 1024,
        "h": 1280,
        "webp": "/works/art-bouquet-pink-oval-1024.webp"
      }
    ],
    "description": "The autumn bouquet embroidered into a rose-pink oval frame, with a single cream rose beside it.",
    "materials": "Hand embroidery, oval frame",
    "tags": [
      "Framed",
      "Floral",
      "Bouquet"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "hamper-wedding-spread",
    "title": "Wedding hamper spread",
    "category": "hampers",
    "image": "/works/hamper-wedding-spread-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 600,
        "webp": "/works/hamper-wedding-spread-480.webp"
      },
      {
        "w": 768,
        "h": 960,
        "webp": "/works/hamper-wedding-spread-768.webp"
      },
      {
        "w": 1024,
        "h": 1280,
        "webp": "/works/hamper-wedding-spread-1024.webp"
      }
    ],
    "description": "A set of netted gift baskets, chocolates and roses laid out together for a wedding.",
    "materials": "Assembled and hand-finished",
    "tags": [
      "Hamper",
      "Wedding",
      "Roses"
    ],
    "featured": true,
    "hasBeforeAfter": false
  },
  {
    "id": "hamper-roses-ferrero",
    "title": "Roses and Ferrero hamper",
    "category": "hampers",
    "image": "/works/hamper-roses-ferrero-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 600,
        "webp": "/works/hamper-roses-ferrero-480.webp"
      },
      {
        "w": 768,
        "h": 960,
        "webp": "/works/hamper-roses-ferrero-768.webp"
      },
      {
        "w": 1024,
        "h": 1280,
        "webp": "/works/hamper-roses-ferrero-1024.webp"
      }
    ],
    "description": "Red and white roses packed around gold-wrapped chocolates in a netted basket.",
    "materials": "Assembled and hand-finished",
    "tags": [
      "Hamper",
      "Roses",
      "Chocolate"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "hamper-birthday-box",
    "title": "Birthday chocolate box",
    "category": "hampers",
    "image": "/works/hamper-birthday-box-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/hamper-birthday-box-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/hamper-birthday-box-768.webp"
      },
      {
        "w": 1024,
        "h": 1365,
        "webp": "/works/hamper-birthday-box-1024.webp"
      }
    ],
    "description": "A window box of chocolates tied with a pink happy-birthday ribbon.",
    "materials": "Assembled, ribboned",
    "tags": [
      "Hamper",
      "Birthday",
      "Chocolate"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "wear-rainbow-frock",
    "title": "Rainbow embroidered frock",
    "category": "designing",
    "image": "/works/wear-rainbow-frock-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 600,
        "webp": "/works/wear-rainbow-frock-480.webp"
      },
      {
        "w": 768,
        "h": 960,
        "webp": "/works/wear-rainbow-frock-768.webp"
      },
      {
        "w": 1024,
        "h": 1280,
        "webp": "/works/wear-rainbow-frock-1024.webp"
      }
    ],
    "description": "A peach cotton frock with a small rainbow and a leafy arc embroidered at the chest.",
    "materials": "Hand embroidery on cotton",
    "tags": [
      "Kids' wear",
      "Embroidered",
      "Frock"
    ],
    "featured": true,
    "hasBeforeAfter": false
  },
  {
    "id": "wear-gingham-butterfly",
    "title": "Gingham butterfly dress",
    "category": "designing",
    "image": "/works/wear-gingham-butterfly-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/wear-gingham-butterfly-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/wear-gingham-butterfly-768.webp"
      },
      {
        "w": 1024,
        "h": 1365,
        "webp": "/works/wear-gingham-butterfly-1024.webp"
      }
    ],
    "description": "A red gingham pinafore dress with a cream yoke and an embroidered butterfly.",
    "materials": "Hand embroidery on gingham",
    "tags": [
      "Kids' wear",
      "Embroidered",
      "Gingham"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "wear-butterfly-detail",
    "title": "Butterfly, up close",
    "category": "designing",
    "image": "/works/wear-butterfly-detail-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/wear-butterfly-detail-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/wear-butterfly-detail-768.webp"
      },
      {
        "w": 1024,
        "h": 1365,
        "webp": "/works/wear-butterfly-detail-1024.webp"
      }
    ],
    "description": "The gingham butterfly at the yoke of the dress, with its stitched leaves.",
    "materials": "Hand embroidery on gingham",
    "tags": [
      "Kids' wear",
      "Detail",
      "Butterfly"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "frame-tawakkul-teal",
    "title": "Tawakkul watercolour frame",
    "category": "frames",
    "image": "/works/frame-tawakkul-teal-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/frame-tawakkul-teal-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/frame-tawakkul-teal-768.webp"
      }
    ],
    "description": "Arabic calligraphy “tawakkul” hand-lettered in ink over a sea-green watercolour wash, set in a slim white frame.",
    "materials": "Watercolour, ink calligraphy, white frame",
    "tags": [
      "Framed",
      "Calligraphy",
      "Watercolour"
    ],
    "featured": true,
    "hasBeforeAfter": false
  },
  {
    "id": "frame-shukr-teal",
    "title": "Shukr watercolour frame",
    "category": "frames",
    "image": "/works/frame-shukr-teal-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/frame-shukr-teal-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/frame-shukr-teal-768.webp"
      }
    ],
    "description": "“Shukr” — gratitude — lettered by hand over a soft green wash and framed in white. Part of a set of three.",
    "materials": "Watercolour, ink calligraphy, white frame",
    "tags": [
      "Framed",
      "Calligraphy",
      "Watercolour"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "frame-sabr-teal",
    "title": "Sabr watercolour frame",
    "category": "frames",
    "image": "/works/frame-sabr-teal-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/frame-sabr-teal-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/frame-sabr-teal-768.webp"
      }
    ],
    "description": "“Sabr” — patience — the third of the set, hand-lettered over a green watercolour wash in a white frame.",
    "materials": "Watercolour, ink calligraphy, white frame",
    "tags": [
      "Framed",
      "Calligraphy",
      "Watercolour"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "frame-kalima-black",
    "title": "Kalima on black frame",
    "category": "frames",
    "image": "/works/frame-kalima-black-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 853,
        "webp": "/works/frame-kalima-black-480.webp"
      },
      {
        "w": 768,
        "h": 1365,
        "webp": "/works/frame-kalima-black-768.webp"
      }
    ],
    "description": "Gold-on-black Arabic calligraphy worked in a circular composition and framed dark, for a wall or a mantel.",
    "materials": "Hand-lettered calligraphy, black frame",
    "tags": [
      "Framed",
      "Calligraphy",
      "Gold"
    ],
    "featured": false,
    "hasBeforeAfter": false
  },
  {
    "id": "hoop-mini-pair",
    "title": "Mini hoop pair",
    "category": "embroidery",
    "image": "/works/hoop-mini-pair-768.webp",
    "imageSet": [
      {
        "w": 480,
        "h": 640,
        "webp": "/works/hoop-mini-pair-480.webp"
      },
      {
        "w": 768,
        "h": 1024,
        "webp": "/works/hoop-mini-pair-768.webp"
      },
      {
        "w": 1024,
        "h": 1365,
        "webp": "/works/hoop-mini-pair-1024.webp"
      }
    ],
    "description": "Two small hoops — a sabr wreath with a red bow and a calligraphy greeting with a yellow ribbon — made to hang together.",
    "materials": "Hand embroidery, satin ribbon",
    "tags": [
      "Hoop art",
      "Calligraphy",
      "Set"
    ],
    "featured": false,
    "hasBeforeAfter": false
  }
];

export default CATALOGUE;
